import styled from "@emotion/styled";
import { css } from "@emotion/react";
import { GhostButton } from "src/components/Buttons";
import { PRIMARY_BLACK } from "src/constants/colors";

export const Container = styled.div<{
  borderType: "solid" | "dashed" | "none";
}>`
  border-bottom: 1px ${(props) => props.borderType} rgba(228, 231, 236, 1);
  display: flex;
  flex-direction: row;
  gap: 10px;
  align-items: center;
  justify-content: space-between;
  padding: 12px 0px;
`;

export const IconContainer = styled.div`
  background-color: rgb(255, 255, 255);
  border: 1px solid rgba(228, 231, 236, 1);
  border-radius: 8px;
  width: 40px;
`;
export const IconHeader = styled.div<{ colorStyle: "blue" | "tan" }>`
  border-radius: 7px 7px 0px 0px;
  display: flex;
  align-items: center;
  justify-content: center;
  height: 16px;
  font-size: 9px;
  font-weight: 700;

  ${({ colorStyle }) => {
    if (colorStyle === "blue") {
      return css`
        background-color: rgba(64, 117, 255, 0.16);
        color: rgba(64, 117, 255, 1);
      `;
    } else if (colorStyle === "tan") {
      return css`
        background-color: rgba(150, 89, 4, 0.16);
        color: rgba(150, 89, 4, 1);
      `;
    }
  }}
`;
export const IconBody = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  height: 24px;
  font-size: 12px;
  font-weight: 700;
`;
export const MainContainer = styled.div`
  display: flex;
  flex: 1;
  flex-direction: column;
  gap: 8px;
  justify-content: center;
`;
export const MainLabel = styled.div`
  color: rgba(74, 84, 102, 1);
  font-size: 12px;
`;
export const MainDate = styled.div`
  color: ${PRIMARY_BLACK};
  font-size: 14px;
  font-weight: 500;
`;
export const UpdateIcon = styled.div`
  cursor: pointer;
`;

export const NoDateContainer = styled.div`
  display: flex;
  flex-direction: row;
  gap: 8px;
  justify-content: space-between;
  align-items: center;
  flex: 1;
`;

export const NoDateLabel = styled.div`
  font-weight: 400;
  font-size: 12px;
  leading-trim: Cap height;
  line-height: 100%;
  letter-spacing: -0.6%;
  color: #4a5466;
`;

export const EnterDateButton = styled(GhostButton)`
  border: none;
  border-radius: 8px;
  gap: 8px;
  padding: 8px 10px;
  color: #1453f5;
`;
